/* eslint-disable react/prop-types */
import React, { useContext } from "react";
//Elements
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
//Context
import { BusinessContextConsumer } from "../BusinessContext";

const NavbarBrand = (props) => {
  const BusinessContext = useContext(BusinessContextConsumer);
  const logo = BusinessContext.logo;
  const logoCheck = logo.length >= 100;
  const tradeName = BusinessContext.tradeName;
  return (
    <Navbar.Brand as={Link} to={props.direction}>
      {logoCheck ? (
        <img src={`data:image/png;base64,${logo}`} className='logo' alt='logo' />
      ) : (
        <span>{tradeName}</span>
      )}
    </Navbar.Brand>
  );
};

export default NavbarBrand;
